import { useState } from "react";
import { Modal } from "src/components/DialogComponent";
import Input from "src/components/ui/Input";
import TGButton from "src/components/ui/TGButton";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";
import { SelectIcon } from "./SelectIcon";

function SelectCommentMobile({
  initial,
  onResult,
  zIndex,
}: {
  initial: string;
  onResult: (text: string) => void;
  zIndex?: number;
}) {
  const [openDialog, setOpenDialog] = useState(false);
  const [comment, setComment] = useState(initial);

  const isEmpty = !comment.length;

  function toggleDialog(state: boolean) {
    setOpenDialog(state);
  }

  function backButton() {
    setOpenDialog(false);
  }

  function submitComment() {
    setOpenDialog(false);
    onResult(comment);
  }

  return (
    <FlexRow
      className={twMerge(
        isEmpty ? "" : "text-black",
        "flex items-center justify-between flex-nowrap p-5 font-medium",
      )}
    >
      <FlexCol className="text-[18px] leading-[28px]">
        <span>Комментарий:</span>
        <span className="block">{isEmpty ? "не указан" : comment}</span>
      </FlexCol>
      <FlexCol className="shrink-0">
        <button onClick={() => toggleDialog(true)}>
          <SelectIcon isSelect={!isEmpty} />
        </button>
      </FlexCol>
      <Modal zIndex={zIndex ? zIndex + 10 : 70} open={openDialog} toggleDialog={toggleDialog}>
        <header className="px-10 pb-4">
          <h2>Укажите комментарий</h2>
        </header>

        <div className="grow px-10 py-5">
          <h4 className="mb-2.5 text-black">Комментарий</h4>
          <Input placeholder="Введите комментарий..." value={comment} onChange={(e) => setComment(e.target.value)} />
        </div>

        <footer className="mt-4 flex justify-between border-t px-10 pt-10">
          <TGButton onClick={backButton}>Отмена</TGButton>
          <TGButton color="bluedark" onClick={submitComment}>
            Сохранить
          </TGButton>
        </footer>
      </Modal>
    </FlexRow>
  );
}

export default SelectCommentMobile;
